import { render } from "./Owners.vue?vue&type=template&id=17a02e83&scoped=true&ts=true"
import script from "./Owners.vue?vue&type=script&lang=ts"
export * from "./Owners.vue?vue&type=script&lang=ts"

import "./Owners.vue?vue&type=style&index=0&id=17a02e83&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a02e83"]])

export default __exports__